/**
 * Helper function to debouce event
 *
 * @param {void} fn function to debouce.
 * @param {int} wait wait time to do function. default=500ms
 * @param {void} time variable to store setTimeout
 *
 * @example
 * debouce(function(){
 * 	//doStuffs()
 * })
 */
export const debounce = (fn, wait = 500, timer) => {
  return function(...args) {
    clearTimeout(
      timer,
      (timer = setTimeout(() => {
        fn.apply(this, args);
      }, wait))
    );
  };
};
